export const C = {
  bg: '#110e1a',
  surface: '#1a1726',
  text: '#e8e4f0',
  muted: '#9892a6',
  primary: '#863bff',
  accent: '#47bfff',
  border: 'rgba(255,255,255,0.06)',
}

export const HERO_ANIM_CSS = `
  @keyframes sf-drift1 {
    0%,100% { transform: translate(0px,   0px)   scale(1);    }
    20%      { transform: translate(70px, -55px)  scale(1.07); }
    45%      { transform: translate(-45px, 80px)  scale(0.94); }
    70%      { transform: translate(60px,  35px)  scale(1.04); }
  }
  @keyframes sf-drift2 {
    0%,100% { transform: translate(0px,   0px)   scale(1);    }
    30%      { transform: translate(-85px, 50px)  scale(1.09); }
    58%      { transform: translate(65px, -75px)  scale(0.91); }
    80%      { transform: translate(-25px,-35px)  scale(1.05); }
  }
  @keyframes sf-drift3 {
    0%,100% { transform: translate(0px,  0px)   scale(1);    }
    35%      { transform: translate(55px, 75px)  scale(0.88); }
    65%      { transform: translate(-50px,-30px) scale(1.11); }
  }
  @keyframes sf-pulse {
    0%,100% { opacity: 1; }
    50%      { opacity: 0.55; }
  }
  @keyframes sf-reveal-pos {
    from { transform: translate(-72%, -62%) scale(0.5); }
    to   { transform: translate(-50%, -40%) scale(1);   }
  }
  @keyframes sf-beam-in {
    from { opacity: 0;    }
    to   { opacity: 0.85; }
  }
`
